import { createReducer, on } from '@ngrx/store'
import * as FeaturePDActions from './feature-pd.actions'
import { FeaturePDState } from './feature-pd.state'

export const initialState: FeaturePDState = {
   result: undefined,
   consortium: undefined,
   finalProposals: undefined,
}

export const featurePDReducer = createReducer(
   initialState,
   on(FeaturePDActions.retriveProject, (state) => ({ ...state, result: undefined })),
   on(FeaturePDActions.retriveProjectSuccess, (state, action) => ({ ...state, result: action.result })),
   on(FeaturePDActions.cleanProjectDetail, (state) => ({
      ...state,
      result: undefined,
      consortium: undefined,
      finalProposals: undefined,
      donwloadFinalProposalsForbidden: undefined,
   })),
   on(FeaturePDActions.retriveProjectConsortium, (state) => ({ ...state, consortium: undefined })),
   on(FeaturePDActions.retriveProjectConsortiumSuccess, (state, action) => ({ ...state, consortium: action.result })),
   on(FeaturePDActions.retriveProjectFinalProposals, (state) => ({ ...state, finalProposals: undefined })),
   on(FeaturePDActions.retriveProjectFinalProposalsSuccess, (state, action) => ({ ...state, finalProposals: action.result })),

   on(FeaturePDActions.downloadFinalProposal, (state, action) => ({
      ...state,
      finalProposals: [
         ...(state.finalProposals?.map((item) => {
            let newItem = { ...item }
            if (item.id == action.fileId) {
               newItem.isLoading = true
            }
            return newItem
         }) ?? []),
      ],
   })),
   on(FeaturePDActions.downloadFinalProposalSuccess, FeaturePDActions.downloadFinalProposalFailure, (state) => ({
      ...state,
      finalProposals: [
         ...(state.finalProposals?.map((item) => {
            let newItem = { ...item }
            if (item.isLoading) {
               newItem.isLoading = false
            }
            return newItem
         }) ?? []),
      ],
   })),
   on(FeaturePDActions.retriveProjectFinalProposalsFailure, (state, action) => ({ ...state, donwloadFinalProposalsForbidden: action.error.status == 403 }))
)
